export default "__VITE_ASSET__39eda017__"